import { useEffect, useState } from "react";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _QualityInspectionProduct, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_BOOLEAN } from "../../../../theme/Component/BasicTable";
import { toast } from "react-toastify";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../../../theme/Component/hooks/useModal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { Modal } from "../../../../theme/Component/Modal";
import { SelectTHConstantsValue } from "../../../../bpm/config/Componentes/SelectTHConstantsValue";
import { InputDate } from "../../../../theme/Input/InputDate";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { QualityInspectionProductItem } from "./QualityInspectionProductItem/QualityInspectionProductItem";
import { FileService } from "../../../../../core/services/FileService";
import { FileInput } from "../../../../theme/Component/FileInput";
import { VisorAnyDocument } from "../../../../documents/VisorAnyDocument";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { QualityInspectionSpecialGarment } from "./QualityInspectionSpecialGarment/QualityInspectionSpecialGarment";
import usePaginator from "../../../../theme/Component/usePaginator";
import { SelectProductEditor } from "../../../ManufacturingStandars/Components/SelectProductEditor";
import { DropDown } from "../../../../theme/Component/DropDown";
import { ExportXLSL } from "../../../../theme/Component/ExportXLSX";

interface ComponentData {
    isModal?: boolean;
    _ProductionOrder?: any;
    isReport?: boolean;
}

interface formData {
    IDCustomer: number;
    IDProduct: number;
    Contract: string;
    State: number;
    FromDate: any;
    UptoDate: any
}

export const QualityInspectionProduct = ({ _ProductionOrder, isModal, isReport }: ComponentData) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_QualityInspectionProduct);
    const fileservice = new FileService();
    const paginator = usePaginator();

    const [form, setForm] = useState<Partial<formData>>({
        State: 1
    })

    const modal = useModal("", MODAL_LG)
    const modalItems = useModal("", MODAL_LG)
    const modalChange = useModal("", MODAL_SM);
    const modalDocument = useModal("Cargar Documento Firmado", MODAL_md);
    const modalSeeDocument = useModal("Ver Documento", MODAL_XL);
    const modalSpecial = useModal("Cumplimiento de Dimensiones Especiales", MODAL_XL);

    useEffect(() => {
        getLista();
    }, [_ProductionOrder, paginator.page])

    const getLista = () => {
        let props: any = {
            IDProduct: _ProductionOrder.IDProduct,
            IDProductionOrder: isReport ? null : _ProductionOrder.IDProductionOrder
        }

        if (form.State) props.State = form.State;
        if (form.Contract) props.NoContract = form.Contract;
        if (form.IDCustomer) props.IDCustomer = form.IDCustomer;
        if (form.IDProduct) props.IDProduct = form.IDProduct;

        instance.getQualityInspectionProductRender(paginator.page, 15, props, form.FromDate, form.UptoDate).then(
            (resp) => {
                paginator.setPages(resp.NumberOfPages);
                paginator.setRecords(resp.NumberOfPages * 15);
                setLista(resp.List)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const create = () => {
        setBean({
            IDProduct: _ProductionOrder.IDProduct,
            IDCustomer: _ProductionOrder.IDAccount,
            IDProductionOrder: _ProductionOrder.IDProductionOrder,
            State: 1,
            ReviewDate: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID(),
            IsEspecialGarment: false,
        });
        modal.open("Agregar Inspección de Producto")
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate() && (!isReport), icono: 'ri-file-add-line', evento: create }
    ]

    const head = [
        { title: 'ID', property: 'IDQualityInspectionProduct', visible: true },
        { title: 'Identificación Tecnica del Producto', property: 'IdentificationTechnicalProduct', visible: true },
        { title: 'Producto', property: 'ProductDescription', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Cliente', property: 'CustomerFullName', visible: true },
        { title: 'No Contrato', property: 'NoContract', visible: true },
        { title: 'Numero de Entrega', property: 'DeliveryNumber', visible: true },
        { title: 'Tipo de Entrega', property: 'DeliveryTypeName', visible: true },
        { title: '¿Es Producto personalizado?', property: 'IsEspecialGarment', visible: true, mask: MASK_BOOLEAN },
        { title: 'Observaciones', property: 'Observation', visible: true },
        { title: 'Fecha de Revisión', property: 'ReviewDate', visible: true },
    ]

    const [confirmAction, setConfirmAction] = useState<() => void>(() => () => { });

    const openConfirm = (text: string, fn: () => void) => {
        setConfirmAction(() => fn);
        modalChange.open(text)
    };

    const changeStateItem = (newState: number) => {
        let x = { ...bean, State: newState };


        editaItem(x);
    };

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit() && (!isReport), evento: () => { modal.open("Editar Inspección de Producto") } },
            { titulo: 'Cargar Documento Firmado', icono: 'mdi mdi-file-upload', visible: _single.canEdit() && (!isReport), evento: () => { modalDocument.open() } },
            { titulo: 'Ver Documento', icono: 'mdi mdi-folder-eye-outline', visible: bean.DocMedia, evento: () => { modalSeeDocument.open() } },
            { titulo: 'Normas y/o Especificaciones', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modalItems.open("Normas y/o Especificaciones") } },
            { titulo: 'Verificaciones de Productos Especiales', icono: 'ri-edit-2-line', visible: (_single.canEdit() && bean.IsEspecialGarment === 1), evento: () => { modalSpecial.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: (_single.canDelete() && bean.State === 1 && (!isReport)), evento: () => { openConfirm("Confirmar Eliminación", () => changeStateItem(3)) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const editaItem = (obj: any) => {
        instance.updateQualityInspectionProduct(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalChange.close();
                modalDocument.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const validateForm = () => {
        const requiredFields = [

        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    const modalGraph = useModal("Reporte Excel", MODAL_SM);
    const [listaExport, setListaExport] = useState<any[]>([]);

    const getListaExport = () => {
        let props: any = {
            IDProduct: _ProductionOrder.IDProduct
        }

        if (form.State) props.State = form.State;
        if (form.Contract) props.NoContract = form.Contract;
        if (form.IDCustomer) props.IDCustomer = form.IDCustomer;
        if (form.IDProduct) props.IDProduct = form.IDProduct;

        instance.getQualityInspectionProductRender(1, 15 * paginator.pages, props, form.FromDate, form.UptoDate).then(
            (resp) => {
                setListaExport(resp.List);
                modalGraph.open();
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const actionsDropDown = [
        { id: 1, name: 'Reporte Excel', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            getListaExport();
                        }
                    }} />
                </div>
            </div>
        )
    }

    const baseComponent = () => {
        return (
            <div className="row">
                <div className="col-md-4">
                    <InputDate name="" value={form.FromDate} label="Fecha desde" setDate={(e) => { setForm({ ...form, FromDate: e }) }} />
                </div>
                <div className="col-md-4">
                    <InputDate name="" value={form.UptoDate} label="Fecha hasta" setDate={(e) => { setForm({ ...form, UptoDate: e }) }} />
                </div>
                <div className="col-md-4">
                    <SelectProductEditor label="Producto" value={form.IDProduct} onChange={(e) => { setForm({ ...form, IDProduct: e.IDProduct }) }} />
                </div>
                <div className="col-md-4">
                    <AccountEditor idAccount={form.IDCustomer} label="Cliente" onChange={(e) => { setForm({ ...form, IDCustomer: e.IDAccount }) }} />
                </div>
                <div className="col-md-4">
                    <label>Contrato</label>
                    <input type="text" value={form.Contract} onChange={(e) => { setForm({ ...form, Contract: e.target.value }) }} className="form-control" />
                </div>
                <div className="col-md-4">
                    <label>Estado</label>
                    <select value={form.State} onChange={(e) => {
                        const value = e.target.value ? Number(e.target.value) : null
                        setForm({ ...form, State: value })
                    }} className="form-select">
                        <option value="">...</option>
                        <option value="1">Creado</option>
                        <option value="3">Eliminado</option>
                    </select>
                </div>
                <div className="col-md-4">
                    <BasicButton useMargin eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} />
                </div>
                <div className="col-md-12">
                    <BasicTable
                        headButtons={buttons()}
                        pageTop={paginator.page}
                        next={paginator.next}
                        back={paginator.back}
                        records={paginator}
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                    />
                </div>
                <div className="col-md-12">

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('WorkShift') ? 'has-error' : ''}`} >Fecha de Revisión</label>
                                <InputDate name="" value={bean.ReviewDate} setDate={(e) => { setBean({ ...bean, ReviewDate: e }) }} label=" " />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDCustomer') ? 'has-error' : ''}`} >Cliente</label>
                                <AccountEditor disabled={_ProductionOrder.IDAccount} idAccount={bean.IDCustomer} label=" " onChange={(e) => { setBean({ ...bean, IDCustomer: e.IDAccount }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('Quantity') ? 'has-error' : ''}`} >Cantidad de productos a revisar</label>
                                <input type="number" value={bean.Quantity} onChange={(e) => { setBean({ ...bean, Quantity: Number(e.target.value) }) }} className="form-control" />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IdentificationTechnicalProduct') ? 'has-error' : ''}`} >Identificación Técnica del Producto</label>
                                <input type="text" value={bean.IdentificationTechnicalProduct} onChange={(e) => { setBean({ ...bean, IdentificationTechnicalProduct: e.target.value }) }} className="form-control" />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('NoContract') ? 'has-error' : ''}`} >No de Contrato</label>
                                <input type="text" value={bean.NoContract} onChange={(e) => { setBean({ ...bean, NoContract: e.target.value }) }} className="form-control" />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('DeliveryType') ? 'has-error' : ''}`} >Tipo de Entrega</label>
                                <SelectTHConstantsValue label=" " code={906} onChange={(e) => { setBean({ ...bean, DeliveryType: e }) }} value={bean.DeliveryType} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('DeliveryNumber') ? 'has-error' : ''}`} >No de Entrega</label>
                                <input type="number" value={bean.DeliveryNumber} onChange={(e) => { setBean({ ...bean, DeliveryNumber: Number(e.target.value) }) }} className="form-control" />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch estado={bean.IsEspecialGarment} eventChange={(e) => { setBean({ ...bean, IsEspecialGarment: e }) }} label="¿Es Producto personalizado?" />
                            </div>
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('Observation') ? 'has-error' : ''}`} >Observaciones</label>
                                <textarea value={bean.Observation} onChange={(e) => { setBean({ ...bean, Observation: e.target.value }) }} className="form-control" />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <div className="row">
                            <div className="col">
                                {lista.length > 0 &&
                                    <ExportXLSL customName={"Productos"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                        _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                    }} />
                                }
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalItems.modal} updateModal={modalItems.setModal} >
                        <QualityInspectionProductItem QualityInspectionProdcut={bean} />
                    </Modal>

                    <Modal modal={modalSpecial.modal} updateModal={modalSpecial.setModal} >
                        <QualityInspectionSpecialGarment QualityInspectionProduct={bean} />
                    </Modal>

                    <Modal modal={modalDocument.modal} updateModal={modalDocument.setModal} eventModal={() => { editaItem(bean) }}  >
                        <FileInput onCreate={(e) => { setBean({ ...bean, DocMedia: e.Media, DocMediaContext: e.MediaContext }) }} Media={bean.DocMedia} MediaContext={bean.DocMediaContext} directory="quality" docAcept={"application/pdf"} label="Documento Firmado" />
                    </Modal>

                    <Modal modal={modalSeeDocument.modal} updateModal={modalSeeDocument.setModal}   >
                        <VisorAnyDocument type="pdf" url={fileservice.getUrlFile(bean.DocMediaContext, bean.DocMedia)} />
                    </Modal>

                    <ModalConfirm modal={modalChange.modal} updateModal={modalChange.setModal} eventModal={() => { confirmAction() }}>
                        <strong>¿Desea Continuar con la accion?</strong>
                    </ModalConfirm>
                </div>
            </div>
        )
    }

    return (
        <>
            {isModal ?
                <>
                    {baseComponent()}
                </>
                :
                <BasicPage titulo="Calidad - Productos">
                    {baseComponent()}
                </BasicPage>
            }
        </>
    )
}